import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { crtb2605NotesComponentRefactor } from 'common/utils/FeatureFlags/flags';
import NotesAdapter from './NotesAdapter';
import NotesLegacy from './NotesLegacy';

const Notes = ({ useAdapter, ...props }) => (
  useAdapter ? <NotesAdapter {...props} /> : <NotesLegacy {...props} />
);

Notes.propTypes = {
  useAdapter: PropTypes.bool,
};

Notes.defaultProps = {
  useAdapter: false,
};

const mapStateToProps = (state) => ({
  useAdapter: crtb2605NotesComponentRefactor(state),
});

export default connect(mapStateToProps)(Notes);
